(() => {
  const initializeGallery = (gallery) => {
    const featuredImage = gallery.querySelector('[data-rp-gallery-main]');
    const controls = gallery.querySelectorAll('[data-rp-gallery-thumb]');
    if (!featuredImage || controls.length === 0) return;

    controls.forEach((control) => {
      control.addEventListener('click', () => {
        const source = control.dataset.rpGallerySrc;
        const alt = control.dataset.rpGalleryAlt;
        if (!source) return;

        controls.forEach((item) => {
          item.classList.remove('is-active');
          item.setAttribute('aria-pressed', 'false');
        });

        control.classList.add('is-active');
        control.setAttribute('aria-pressed', 'true');
        featuredImage.classList.add('is-changing');

        window.setTimeout(() => {
          featuredImage.src = source;
          featuredImage.alt = alt || '';
          featuredImage.classList.remove('is-changing');
        }, 110);
      });
    });
  };

  const initializeAll = () => {
    document.querySelectorAll('[data-rp-gallery]').forEach(initializeGallery);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeAll, { once: true });
  } else {
    initializeAll();
  }
})();
